import { Role } from "../../model/domain/Role";

export class Group {
  id = 0;
  name: string = null;

  roles: Role[] = null;
}
